// extracted by mini-css-extract-plugin
export default {"mabf_container":"S1_BestFit_mabf_container__LOAiM","mabf_desc":"S1_BestFit_mabf_desc__ktinY"};